<template>
  <div
    class="relative"
    :class="{ 'set-active': selected }"
  >
    <NuxtLink
      :to="to"
      class="sticky-navigation-menu-item flex flex-col absolute left-0 right-0 mx-auto top-0"
      :class="{
        'sticky-navigation-menu-item-active pb-2': selected
      }"
    >
      <span class="block pb-rem">
        <OSvg
          class="w-5 mx-auto"
          :svg="`${svgPrefix}-${selected ? 'solid' : 'outline'}`"
          :class="{
            'fill-newBlue-400': selected,
            'fill-neutral-800': !selected
          }"
        />
      </span>
      <span
        class="o-footer text-center"
        :class="{
          'font-bold text-newBlue-400': selected,
          'text-neutral-800': !selected
        }"
        v-text="text"
      />
    </NuxtLink>
  </div>
</template>

<script>
import OSvg from '@/components/OSvg'

export default {
  name: 'StickyNavigationMenuItem',
  components: { OSvg },
  props: {
    svgPrefix: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    selected: {
      type: Boolean,
      default: false
    },
    to: {
      type: Object,
      default: () => ({}),
      validator: value => value.hasOwnProperty('path')
    }
  }
}
</script>

<style lang="postcss" scoped>
.sticky-navigation-menu-item {
  @apply transition-all duration-200 delay-100 ease-in;

  &-active {
    top: -1rem !important;
  }
}
</style>
